import React from 'react';
import LocalizedMessage from 'react-l10n';

function PrintPackingLabelButton(props) {
    return (
        <a
            href={props.url || 'javascript:void(0)'}
            target='_blank'
            className='button button--border button--small button--thin'
        >
            <span className='icon icon-print' />
            <span>
                <LocalizedMessage id={'PRINT_PACKING_LABEL'} />
            </span>
        </a>
    );
}

export default PrintPackingLabelButton;
